import { Phone, Mail, MapPin, Clock } from "lucide-react";
import PageHero from "@/components/PageHero";
import ContactForm from "@/components/ContactForm";
import Reveal from "@/components/Reveal";
import { SITE } from "@/lib/api";

const INFO = [
  {
    icon: MapPin,
    title: "Sede",
    lines: [SITE.legalName, SITE.address],
  },
  {
    icon: Phone,
    title: "Telefono",
    lines: [SITE.phoneDisplay, SITE.hours],
    href: `tel:${SITE.phone}`,
    testId: "contact-info-phone",
  },
  {
    icon: Mail,
    title: "Email",
    lines: [SITE.email],
    href: `mailto:${SITE.email}`,
    testId: "contact-info-email",
  },
  {
    icon: Clock,
    title: "Orari di segreteria",
    lines: ["Dal lunedì al venerdì", "dalle 10.00 alle 16.00"],
  },
];

export default function Contatti() {
  return (
    <main>
      <PageHero
        eyebrow="Contatti"
        titleLines={["Cogli l'occasione:", "inizia con il primo passo."]}
        subtitle="Senza il minimo impegno. Utilizza il modulo per rivolgerci qualsiasi domanda sui corsi e sulle possibilità che possiamo offrirti: il nostro team è a tua disposizione."
      />

      <section className="mx-auto max-w-7xl px-5 py-12 pb-28 sm:px-8" data-testid="contacts-section">
        <div className="grid gap-8 lg:grid-cols-12">
          <div className="space-y-5 lg:col-span-5">
            {INFO.map((item, i) => (
              <Reveal key={item.title} delay={0.06 * i}>
                <div className="rounded-3xl border border-[#D8E5E8] bg-white p-6 shadow-[0_10px_40px_-28px_rgba(16,51,59,0.3)] transition-colors duration-300 hover:border-[#1F8296]/50">
                  <div className="flex items-center gap-3">
                    <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-[#1F8296]/30 bg-[#1F8296]/10">
                      <item.icon className="h-5 w-5 text-[#1F8296]" />
                    </div>
                    <h2 className="font-display text-lg font-semibold text-[#1A2E33]">{item.title}</h2>
                  </div>
                  <div className="mt-4 space-y-1 text-sm text-[#5C7178]">
                    {item.lines.map((line) =>
                      item.href ? (
                        <a
                          key={line}
                          href={item.href}
                          data-testid={item.testId}
                          className="block font-semibold text-[#1F8296] transition-colors hover:text-[#238496]"
                        >
                          {line}
                        </a>
                      ) : (
                        <p key={line}>{line}</p>
                      )
                    )}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="lg:col-span-7" delay={0.1}>
            <div className="relative overflow-hidden rounded-[28px] border border-[#D8E5E8] bg-white p-7 shadow-[0_20px_60px_-35px_rgba(16,51,59,0.4)] sm:p-10">
              <div className="bg-grid-pattern pointer-events-none absolute inset-0 opacity-40" />
              <div className="relative">
                <h2 className="font-display text-2xl font-semibold text-[#1A2E33]">Scrivici un messaggio</h2>
                <p className="mt-2 text-sm text-[#5C7178]">
                  Compila il modulo: salviamo la tua richiesta e ti ricontattiamo al più presto.
                </p>
                <div className="mt-8">
                  <ContactForm />
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="mt-8 overflow-hidden rounded-[28px] border border-[#D8E5E8] bg-white shadow-[0_20px_60px_-35px_rgba(16,51,59,0.4)]" data-testid="map-section">
            <div className="flex flex-wrap items-center justify-between gap-3 p-6 pb-4">
              <div className="flex items-center gap-3">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-[#1F8296]/30 bg-[#1F8296]/10">
                  <MapPin className="h-5 w-5 text-[#1F8296]" />
                </div>
                <div>
                  <h2 className="font-display text-lg font-semibold text-[#1A2E33]">Dove siamo</h2>
                  <p className="text-sm text-[#5C7178]">{SITE.address}</p>
                </div>
              </div>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Via+Sostegno+25%2C+24124+Brescia+BS"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="map-directions-link"
                className="rounded-full border border-[#C9DBDF] px-5 py-2.5 text-sm font-semibold text-[#1F8296] transition-colors hover:border-[#1F8296]/60"
              >
                Indicazioni stradali (Google Maps)
              </a>
            </div>
            <iframe
              title="Mappa della sede: Via Sostegno 25, Brescia"
              src="https://www.openstreetmap.org/export/embed.html?bbox=10.2153535%2C45.5226231%2C10.2313535%2C45.5346231&layer=mapnik&marker=45.5286231%2C10.2233535"
              className="h-80 w-full border-0"
              loading="lazy"
            />
          </div>
        </Reveal>
      </section>
    </main>
  );
}
